import { render, staticRenderFns } from "./AdminTotals.vue?vue&type=template&id=dd4cdf8c&scoped=true"
import script from "./AdminTotals.vue?vue&type=script&lang=js"
export * from "./AdminTotals.vue?vue&type=script&lang=js"
import style0 from "./AdminTotals.vue?vue&type=style&index=0&id=dd4cdf8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4cdf8c",
  null
  
)

export default component.exports